<!-- 发送记录 -->
<template>
  <div class="page">
    <p class="p16">发送记录</p>
    <div class="page-head">
      <div class="mains-content br10">
        <div class="member-content-box">
        <div class="member-header space-between">
          <div>
            <el-date-picker v-model="query.dataMonth" type="month" value-format="yyyy-MM" placeholder="选择月" @change="totalCounts" :clearable="false"></el-date-picker>
          </div>
          <el-button type="primary" class="mt10 ml10 mb10" @click="sendMessage" v-perm="{key:'customerInfo', value: 'customerInfo:send'}">发送短信</el-button>
        </div>
          <div v-perm="{key:'customerInfo', value: 'customerInfo:list'}">
            <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="title" label="发送标题" width="auto"  min-width="200px"></el-table-column>
              <el-table-column prop="itemNum" label="发送数量" width="auto"></el-table-column>
              <el-table-column prop="oxCname" width="auto" label="发送人"></el-table-column>
              <el-table-column prop="oxLtime" label="发送时间" width="auto" min-width="150px">
                <template slot-scope="scope">{{ formatDate(scope.row.oxLtime) }}</template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                    <el-link type="primary" @click="details(scope.row)">详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <detail-set ref="detailSetForm" @change="handleChange"></detail-set>
    <add-page ref="addForm" @change="onChange"></add-page>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import detailSet from "./detail";
import addPage from "./add.vue";
export default {
  data() {
    return {
      url: this.$url.smsTemplate.messageList,
      urlCount: this.$url.smsTemplate.messageCount,
      query: {
        start: 1,
        size: 20,
		dataMonth:this.formatMonth(new Date()),
        moduleType: 'customerInfo',
      },
      list: [],
      staffList: [],
      height: this.$store.getters.MainHeight,
    };
  },
  mixins: [minxin],
  components: { detailSet,addPage },
  computed: {},

  created() {
    this.totalCounts();
    this.getStaff();
    
  },
  mounted () {
    if (sessionStorage.getItem("sendSms")) {
      this.$refs["addForm"].$emit("set", JSON.parse(sessionStorage.getItem("sendSms")));
      sessionStorage.removeItem("sendSms")
    }
  },
  methods: {
    back() {
      this.$router.push("/dataList");
    },
    onChange (org) {
      if (org) {
        this.query.start = 1;
        this.getTotalList()
      };
    },
    details (row) {
      console.log(row);
      if (Object.keys(row).length !== 0) {
        this.$refs["detailSetForm"].$emit("set", row.id);
      }
    },
    getStaff () {
      this.$api.post(this.$url.companyStaff.listAuthForData).then(res => {
        if (res) {
            this.staffList = res;
        }
      })
    },
    totalCounts () {
      this.totalCount = 0;
      this.getTotalList();
      this.$api.post(this.$url.smsTemplate.messageCount, this.query).then(res => {
        
        this.totalCount = res;
      }).catch(error => {});
    },
    getTotalList () {
      this.$api.post(this.$url.smsTemplate.messageList, this.query).then(res => {
        if (res) this.list = res;
        console.log(res,'sres');
      }).catch(error => {});
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    sendMessage () {
      this.$refs["addForm"].$emit("set", true);
    },
    selectChange() {
      this.totalCounts();
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  background: #fff;
  .member-header {
    width: calc(100% - 32px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .member-header-first {
      display: flex;
      // flex: 1;
      flex-wrap: wrap;
    }
  }
}

.select200 {
  width: 200px;
}
</style>

